import { createHttpLink, split } from "@apollo/client";
import { GRAPH_ENDPOINT, GRAPH_ENDPOINT_AUTH, GRAPH_ENDPOINT_B2B, GRAPH_ENDPOINT_CENTRALIZED, GRAPH_ENDPOINT_PAYMENTS, GRAPH_ENDPOINT_SEARCH, GRAPH_ENDPOINT_SUBSCRIPTIONS, GRAPH_ENDPOINT_TALENT_FEEDBACK, GRAPH_ENDPOINT_V3, GRAPH_ENDPOINT_V4, GRAPH_ENDPOINT_V4_AUTHENTICATION, GRAPH_ENDPOINT_V4_B2B, GRAPH_ENDPOINT_V4_STAFF, GRAPH_ENDPOINT_V5, GRAPH_ENDPOINT_V5_ANALYTICS } from "../constants.js";
function createIsomorphLink() {
    const common = {
        credentials: 'include'
    };
    const mainLink = createHttpLink({
        uri: GRAPH_ENDPOINT,
        ...common
    });
    const auth = split((operation)=>'auth' === operation.getContext().clientName, createHttpLink({
        uri: `${GRAPH_ENDPOINT_AUTH}`,
        ...common
    }), mainLink);
    const b2bLink = split((operation)=>'b2b' === operation.getContext().clientName, createHttpLink({
        uri: `${GRAPH_ENDPOINT_B2B}`,
        ...common
    }), auth);
    const v4Link = split((operation)=>'v4' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_V4,
        ...common
    }), b2bLink);
    const v4AuthenticationLink = split((operation)=>'v4.authentication' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_V4_AUTHENTICATION,
        ...common
    }), v4Link);
    const v4b2bLink = split((operation)=>'v4.b2b' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_V4_B2B,
        ...common
    }), v4AuthenticationLink);
    const v3Link = split((operation)=>'v3' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_V3,
        ...common
    }), v4b2bLink);
    const v4staffLink = split((operation)=>'v4.staff' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_V4_STAFF,
        ...common
    }), v3Link);
    const paymentsLink = split((operation)=>'payments' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_PAYMENTS,
        ...common
    }), v4staffLink);
    const v5Link = split((operation)=>'v5' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_V5,
        ...common
    }), paymentsLink);
    const subscriptionsLink = split((operation)=>"subscriptions" === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_SUBSCRIPTIONS,
        ...common
    }), v5Link);
    const v5AnalyticsLink = split((operation)=>'v5.analytics' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_V5_ANALYTICS,
        ...common
    }), subscriptionsLink);
    const talentLink = split((operation)=>'talent.feedback' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_TALENT_FEEDBACK,
        ...common
    }), v5AnalyticsLink);
    const schemaLinks = split((operation)=>'search' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_SEARCH,
        ...common
    }), talentLink);
    const centralizedLink = split((operation)=>'centralized' === operation.getContext().clientName, createHttpLink({
        uri: GRAPH_ENDPOINT_CENTRALIZED,
        ...common
    }), schemaLinks);
    const mockV5Link = split((operation)=>'mock.v5' === operation.getContext().clientName, createHttpLink({
        uri: `${process.env.API_URL_MOCK}/api/v5/graph/`,
        ...common
    }), centralizedLink);
    const mockCentralizedLink = split((operation)=>'mock.centralized' === operation.getContext().clientName, createHttpLink({
        uri: `${process.env.API_URL_MOCK}/api/graph/centralized/`,
        ...common
    }), mockV5Link);
    const mockMainLink = split((operation)=>'mock.v2' === operation.getContext().clientName, createHttpLink({
        uri: `${process.env.API_URL_MOCK}/api/v2/graph/`,
        ...common
    }), mockCentralizedLink);
    return mockMainLink;
}
const links_createIsomorphLink = createIsomorphLink;
export default links_createIsomorphLink;
